var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Presentation'),_c('ListImgLeft'),_c('Temoignages'),_c('SubscribeForm'),_c('TextBoxImgRight'),_c('BoxIcon'),_c('TextBand'),_c('TextOverSizeImg'),_c('TagList'),_c('TextBoxImgLeft')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }